<div class="container">
    <div class="row d-flex flex-wrap">
        <div class="col-12 col-sm-12 col-md-3">
            <h2 class="orange-header">Quick Pay</h2>
            <p>Create and send quick payment links</p><br>

            <h3>Use This When:</h3>
            <ul>
                <li>you don't need an invoice</li>
                <li>you want to send a quick payment link via SMS, WhatsApp or other social media platform</li>
            </ul>

            <h3>Your customer will receive:</h3>
            <ul>
                <li>a payment link/code for both in-store or online payments</li>
            </ul>
        </div>

        <div class="col-12 col-sm-12 col-md-9 justify-content-center align-self-center">
            <img [ngSrc]="'walkthrough-quickpay.gif' | assetSource"
                 alt="quick pay image"
                 class="walkthrough-image responsive-gif align-middle"
                 height="1"
                 width="1"/>
        </div>
    </div>
</div>
